import React from 'react';
import PropTypes from 'prop-types';
import { Link, Title } from '@express-labs/raven-ui';
import s from './MyAccountAuxiliaryNav.module.scss';

function MyAccountAuxiliaryNav({ links }) {
  return (
    <div className={s.help}>
      <Title tag="h4" className={s.helpTitle}>Help &amp; More</Title>
      {links
        && links.map((val) => (
          <Link key={val.linkId} href={val.path} className={s.helpLink} aria-label={val.title}>
            {val.title}
          </Link>
        ))}
    </div>
  );
}

MyAccountAuxiliaryNav.meta = {
  VERSION: '1.0.0',
};

MyAccountAuxiliaryNav.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      path: PropTypes.string,
      linkId: PropTypes.string,
    }),
  ).isRequired,
};

export default MyAccountAuxiliaryNav;
